import { useEffect, useState } from 'react';
import CustomTable from '../../../CustomTable/CustomTable';
import { useAppDispatch } from '../../../../../Hooks/Hooks';
import { DeviceInfoDataRender } from '../../../../../Utils/DeviceInfo';
import { arrayToObject, getBase64PDFfileURL } from '../../../../../Utils/Basic';
import {
  getDocumentBase64Data,
  getDocumentListData,
} from '../../../../../Redux/Reducers/MyLoadsSlice';
import './LoadDocumentsContainer.scss';

const LoadDocumentsContainer = (props: any) => {
  const { id, sourceTms, modalView } = props;
  const dispatch = useAppDispatch();
  const [documentList, setDocumentList] = useState<any[]>([]);
  const [RelatedDocumentList, setRelatedDocumentList] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState(0);
  const showPDFDocument = (documentData: any) => {
    const deviceInformation = arrayToObject(DeviceInfoDataRender());
    const requestPayLoad = {
      shipmentId: documentData.shipmentId,
      sourceTms: sourceTms,
      documentNumber: documentData.documentNumber,
    };
    dispatch(getDocumentBase64Data(requestPayLoad)).then((response: any) => {
      if (response?.payload) {
        const base64PDFfileURL = getBase64PDFfileURL(response.payload?.documents[0]?.content) || '';
        if (deviceInformation.browser_name === 'Safari') {
          const link = document.createElement('a');
          link.href = base64PDFfileURL;
          link.target = '_blank';
          link.download = 'document.pdf';
          link.click();
        } else {
          window?.open(base64PDFfileURL, '_blank');
        }
      } else {
        console.error('Error in fetching report data');
      }
    });
  };

  useEffect(() => {
    const requestPayLoad = {
      shipmentId: id,
      sourceTms: sourceTms,
    };
    dispatch(getDocumentListData(requestPayLoad)).then((response: any) => {
      response?.payload?.documents && setDocumentList(response.payload.documents);
      response?.payload?.relatedDocuments &&
        setRelatedDocumentList(response.payload.relatedDocuments);
    });
  }, []);

  return (
    <div className="LoadDocumentsContainer">
      <div className="tab-content">
        <CustomTable
          data={activeTab === 0 ? documentList : RelatedDocumentList}
          tableLabel={
            <div className="tab-buttons-container">
              <div
                className={`tab-button available-documents-button ${activeTab === 0 ? 'active' : ''}`}
                onClick={() => setActiveTab(0)}
              >
                Available Documents
              </div>
              <div
                className={`tab-button related-documents-button ${activeTab === 1 ? 'active' : ''}`}
                onClick={() => setActiveTab(1)}
              >
                Related Documents
              </div>
            </div>
          }
          additionalClass="Documents_List"
          modalView={modalView}
          callback={showPDFDocument}
        />
      </div>
    </div>
  );
};
export default LoadDocumentsContainer;
